export function loanDemandRequest(state = {
    fetching:false,
    fetched: false,
    fetchedAll: false, // ?
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_LOAN_DEMAND_START":           
        case "FETCH_LOAN_DEMANDS_START":                                 
        case "UPDATE_LOAN_DEMAND_START":                                 
        case "DELETE_LOAN_DEMAND_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_LOAN_DEMAND_FULFILLED":           
        case "FETCH_LOAN_DEMANDS_FULFILLED":                                 
        case "UPDATE_LOAN_DEMAND_FULFILLED":                                 
        case "DELETE_LOAN_DEMAND_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_LOAN_DEMAND_ERROR":
        case "FETCH_LOAN_DEMANDS_ERROR":
        case "UPDATE_LOAN_DEMAND_ERROR":
        case "DELETE_LOAN_DEMAND_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}